import { SET_RECEIPT_IS_LOADING } from '../../actionTypes/receipt'

export const setReceiptIsLoading = value => ({ type: SET_RECEIPT_IS_LOADING, value })